import saveFileTemplate from './view.html';

import { SaveFileController } from '../saveFile/controller';

const ClassicMenuSaveFileComponent = {
    template: saveFileTemplate,
    controller: SaveFileController,
    controllerAs: '$',
    scope: true,
    bindings: {
        fileType: '@',
        iconClass: '@',
        linkClass: '@',
        errorClass: '@',
        errorPosition: '@',
        accessSection: '@',
        accessRight: '@',
        id: '<',
        disabled: '<',
        linkText: '<',
        loadingText: '<',
        errorText: '<',
        setLoading: '<',
        setError: '<',
        filterDates: '<',
        onClickLink: '<',
    },
};

export {
    ClassicMenuSaveFileComponent,
};
